import { ZodError } from 'zod';

export class ValidatorUtils {
    static getIssuesMessage = (error: ZodError) => {
        const issueMessages: string[] = [];
        for (const issue of error.issues) {
            const path = issue.path.join('.');
            issueMessages.push(`[${path}]: ${issue.message}`);
        }
        const issuesMessage = issueMessages.join('. ');
        return `Input Validation Failed: ${issuesMessage}`;
    };

    static sanitizeString = (text: string) => {
        return text
            .replace(/&(?!amp;|lt;|gt;|quot;)/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    };
}
